import { useEffect } from 'react';
import { Layout } from './Layout';
import { LayoutWCAG } from './LayoutWCAG';

export type ProtectedRouteProps = {
    Component: any,
    title: string,
};

export default function LayoutRouterWCAG({ Component, title }: ProtectedRouteProps) {

    useEffect(() => {
        document.title = title;
    }, [])
    
    return (

        <LayoutWCAG title={title}>
            <Component />
        </LayoutWCAG>
    )

};